import {
  Button,
  Checkbox,
  Radio,
  Row,
  Form,
  Input,
  Space,
  Table,
  Col,
  Modal,
  Popover,
  Tabs,
  Empty,
  ConfigProvider,
} from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, Fragment, useState } from "react";
import type { MenuProps, TabsProps } from "antd";
import { Menu } from "antd";
import { UserPermissionStore, CommonStore } from "../../../store";
import { useLocation } from "react-router-dom";
import {
  DownOutlined,
  UpOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import "./index.css";

const { Column } = Table;

function PermissionPage(props: any) {
  const [open, setOpen] = useState(false);
  const [openLook, setOpenLook] = useState(false);
  const [form] = Form.useForm();
  const [current, setCurrent] = useState("mail");
  const location = useLocation();
  const onClick: MenuProps["onClick"] = (e) => {
    Object.keys(UserPermissionStore.getAble).forEach((item: any) => {
      if (UserPermissionStore.visitedPermissions[item]) {
        UserPermissionStore.visitedPermissions.resourceList.forEach(
          (item1: any) => {
            item1[UserPermissionStore.getAble[item]] = true;
            item1[
              UserPermissionStore.getOperable[UserPermissionStore.getAble[item]]
            ] = false;
          }
        );
      }
    });

    UserPermissionStore.allVisitedPermissions[CommonStore.managementResource] =
      { ...UserPermissionStore.visitedPermissions };
    CommonStore.findKey(CommonStore.MenuRouter, e.key);
    CommonStore.permissionBreadcrumbData();
    UserPermissionStore.getPermissionPData();
    setCurrent(e.key);
  };

  const showLookDrawer = (record: any) => {
    console.log(UserPermissionStore.searchForm.subject);

    UserPermissionStore.getPermissionPData(record, CommonStore.MenuRouter);
    setCurrent(location.pathname);
    setOpen(true);
  };

  const onClose = () => {
    UserPermissionStore.allVisitedPermissions = {};
    setOpen(false);
    setOpenLook(false);
  };

  const save = () => {
    setOpen(false);
    UserPermissionStore.setPermissionPData();
  };

  useEffect(() => {
    form.setFieldsValue({ displayName: "" });
    // CommonStore.getPagePermission("user_permission");
    UserPermissionStore.setSearchForm({ subject: "group" });
    // UserPermissionStore.getUserPermissionPage();
    resetSearchbth(); //重新设置subject后在重置
  }, []);
  const getFormData = (
    changeValues?: powerSearchData,
    allValues?: powerSearchData
  ) => {
    if (allValues) {
      allValues.subject = UserPermissionStore.searchForm.subject;
    }
    UserPermissionStore.setSearchForm({ ...allValues });
  };
  const searchBtn = () => {
    UserPermissionStore.resetPage();
    UserPermissionStore.getUserPermissionPage();
  };
  const resetSearchbth = () => {
    UserPermissionStore.setSearchForm({
      subject: UserPermissionStore.searchForm.subject,
    });
    UserPermissionStore.resetPage();
    UserPermissionStore.getUserPermissionPage();
  };

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const onChange = (key: string) => {
    form.setFieldsValue({ displayName: "" });
    if (key === "group") {
      UserPermissionStore.setSearchForm({ subject: "group" });
    } else {
      UserPermissionStore.setSearchForm({ subject: "account" });
    }
    UserPermissionStore.resetPage();
    UserPermissionStore.getUserPermissionPage();
  };

  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "group",
      label: "用户组",
      children: (
        <ConfigProvider renderEmpty={tableEmptyRender}>
          <Table
            dataSource={UserPermissionStore.tableData.records}
            rowKey={(record: { no: string }) => record.no}
            loading={UserPermissionStore.tableLoad}
            pagination={{
              current: UserPermissionStore.pageData.page,
              pageSize: UserPermissionStore.pageData.size,
              onChange: UserPermissionStore.pageData.changePage,
              pageSizeOptions: [10, 25, 50],
              showSizeChanger: true,
              total: UserPermissionStore.tableData.total,
              showTotal: () => `共计${UserPermissionStore.tableData.total}条`,
              position: ["bottomLeft"],
            }}
          >
            <Column ellipsis={true} title="名称" dataIndex="displayName" />
            <Column
              width={120}
              fixed={"right"}
              title={() => {
                return (
                  <>
                    <Popover
                      placement="bottom"
                      content={() => {
                        return (
                          <ul style={{ width: "200px", padding: "0 0 0 21px" }}>
                            <li>
                              用户可通过关联用户组或直接给个人授权两种方式来获取权限
                            </li>
                            <li>
                              若用户创建一个新的资源，该用户个人权限中默认拥有该资源的管理权限
                            </li>
                          </ul>
                        );
                      }}
                    >
                      <InfoCircleOutlined className="tips" />
                    </Popover>
                  </>
                );
              }}
              render={(text: string, record: any) => (
                <Space>
                  <Button onClick={() => showLookDrawer(record)}>
                    功能权限
                  </Button>
                </Space>
              )}
            />
          </Table>
        </ConfigProvider>
      ),
    },
    {
      key: "account",
      label: "个人",
      children: (
        <ConfigProvider renderEmpty={tableEmptyRender}>
          <Table
            dataSource={UserPermissionStore.tableData.records}
            rowKey={(record: { no: string }) => record.no}
            loading={UserPermissionStore.tableLoad}
            pagination={{
              current: UserPermissionStore.pageData.page,
              pageSize: UserPermissionStore.pageData.size,
              onChange: UserPermissionStore.pageData.changePage,
              pageSizeOptions: [10, 25, 50],
              showSizeChanger: true,
              total: UserPermissionStore.tableData.total,
              showTotal: () => `共计${UserPermissionStore.tableData.total}条`,
              position: ["bottomLeft"],
            }}
          >
            <Column ellipsis={true} title="名称" dataIndex="displayName" />
            <Column
              width={120}
              fixed={"right"}
              title={() => {
                return (
                  <>
                    <Popover
                      placement="bottom"
                      content={() => {
                        return (
                          <ul style={{ width: "200px", padding: "0 0 0 21px" }}>
                            <li>
                              用户可通过关联用户组或直接给个人授权两种方式来获取权限
                            </li>
                            <li>
                              若用户创建一个新的资源，该用户个人权限中默认拥有该资源的管理权限
                            </li>
                          </ul>
                        );
                      }}
                    >
                      <InfoCircleOutlined className="tips" />
                    </Popover>
                  </>
                );
              }}
              render={(text: string, record: any) => (
                <Space>
                  <Button onClick={() => showLookDrawer(record)}>
                    功能权限
                  </Button>
                </Space>
              )}
            />
          </Table>
        </ConfigProvider>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="formContent">
        <Form
          form={form}
          initialValues={UserPermissionStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <Form.Item label="名称" name="displayName">
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col offset={2}>
              <Form.Item>
                <Space>
                  <Button type="primary" onClick={searchBtn}>
                    搜索
                  </Button>
                  <Button htmlType="reset" onClick={() => resetSearchbth()}>
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Tabs defaultActiveKey={"1"} items={items} onChange={onChange}></Tabs>
      </div>
      <Modal
        centered
        className="modal"
        width={"1000px"}
        onCancel={onClose}
        open={open}
        onOk={save}
        footer={[
          <Button key="back" onClick={onClose}>
            取消
          </Button>,
          <Button
            style={{ marginRight: "30px" }}
            key="submit"
            type="primary"
            onClick={save}
            disabled={!UserPermissionStore.manageablePermission}
          >
            确定
          </Button>,
          <div
            key="tips"
            style={{
              fontSize: "10px",
              marginRight: "30px",
              marginTop: "10px",
              color: "#a6a8ab",
            }}
          >
            {!UserPermissionStore.manageablePermission
              ? "为用户组或个人分配权限需拥有对应主体的管理权限"
              : " "}
          </div>,
        ]}
      >
        <div ><div
          style={{
            lineHeight: "40px",
            backgroundColor: "#fff",
            verticalAlign: "middle",
            padding: "10px 20px",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <div
            style={{ width: "350px" }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div className="topTitle">
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "500",
                  color: "#000",
                  opacity: "0.85",
                }}
              >
                {CommonStore.permissionbreadcrumbTitle[0]
                  ? CommonStore.permissionbreadcrumbTitle[0].title
                  : ""}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#000",
                  opacity: "0.45",
                }}
              >
                {CommonStore.permissionbreadcrumbTitle[1]
                  ? " " +
                    "/" +
                    " " +
                    CommonStore.permissionbreadcrumbTitle[1].title
                  : ""}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#000",
                  opacity: "0.45",
                }}
              >
                {CommonStore.permissionbreadcrumbTitle[2]
                  ? " " +
                    "/" +
                    " " +
                    CommonStore.permissionbreadcrumbTitle[2].title
                  : ""}
              </span>
              {!isHovered && <DownOutlined />}
              {isHovered && <UpOutlined />}
            </div>
            {isHovered && (
              <Menu
                className="breadcrumb"
                mode="vertical"
                onClick={onClick}
                items={CommonStore.permissionnewMenuRouter}
              />
            )}
          </div>
        </div>
        <div className="permissionTop">
          <div className="readTop">
            <span style={{ fontSize: "20px", paddingRight: "10px" }}>查看</span>{" "}
            <Checkbox
              onChange={(e) => UserPermissionStore.topCheckbox(e, "readable")}
              checked={UserPermissionStore.data.readable}
              disabled={!UserPermissionStore.data.readOperable}
              style={{ fontSize: "22px", paddingBottom: "16px" }}
            ></Checkbox>
            <Popover
              placement="bottom"
              className="tips1"
              content={() => {
                return (
                  <ul style={{ width: "225px", padding: "0 0 0 15px" }}>
                    <li>
                      用户对该页面的查看权限，勾选后可操作页面下挂资源的查看权限。
                    </li>
                    <li>
                      勾选查看全部表示用户可以查看页面下挂的所有资源，包括之后页面新增的资源
                    </li>
                  </ul>
                );
              }}
            >
              <InfoCircleOutlined className="tips" />
            </Popover>
            {UserPermissionStore.data.hasChildResource && (
              <div className="readRadio">
                <Radio.Group
                  onChange={(e) =>
                    UserPermissionStore.onChangeRadio(e, "readAll")
                  }
                  value={UserPermissionStore.data.readAll}
                  disabled={
                    !UserPermissionStore.data.readAllOperable ||
                    !UserPermissionStore.data.readable
                  }
                >
                  <Radio value={true}>全部</Radio>
                  <Radio value={false}>仅勾选</Radio>
                </Radio.Group>
              </div>
            )}
          </div>
          <div className="readTop">
            <span style={{ fontSize: "20px", paddingRight: "10px" }}>编辑</span>{" "}
            <Checkbox
              onChange={(e) => UserPermissionStore.topCheckbox(e, "writable")}
              checked={UserPermissionStore.data.writable}
              disabled={!UserPermissionStore.data.writeOperable}
              style={{ fontSize: "22px", paddingBottom: "16px" }}
            ></Checkbox>
            <Popover
              placement="bottom"
              className="tips1"
              content={() => {
                return (
                  <ul style={{ width: "225px", padding: "0 0 0 15px" }}>
                    <li>
                      用户对该页面的编辑权限，勾选后可操作页面下挂资源的编辑权限。
                    </li>
                    <li>页面或某个资源的编辑权限默认拥有其查看权限。</li>
                    <li>
                      勾选编辑全部表示用户可以编辑页面下挂的所有资源，包括之后页面新增的资源
                    </li>
                  </ul>
                );
              }}
            >
              <InfoCircleOutlined className="tips" />
            </Popover>
            {UserPermissionStore.data.hasChildResource && (
              <div className="readRadio">
                <Radio.Group
                  onChange={(e) =>
                    UserPermissionStore.onChangeRadio(e, "writeAll")
                  }
                  value={UserPermissionStore.data.writeAll}
                  disabled={
                    !UserPermissionStore.data.writeAllOperable ||
                    !UserPermissionStore.data.writable
                  }
                >
                  <Radio value={true}>全部</Radio>
                  <Radio value={false}>仅勾选</Radio>
                </Radio.Group>
              </div>
            )}
          </div>
          <div className="readTop">
            <span style={{ fontSize: "20px", paddingRight: "10px" }}>授权</span>{" "}
            <Checkbox
              onChange={(e) => UserPermissionStore.topCheckbox(e, "grantable")}
              checked={UserPermissionStore.data.grantable}
              disabled={!UserPermissionStore.data.grantOperable}
              style={{ fontSize: "22px", paddingBottom: "10px" }}
            ></Checkbox>
            <Popover
              placement="bottom"
              className="tips1"
              content={() => {
                return (
                  <ul style={{ width: "225px", padding: "0 0 0 15px" }}>
                    <li>
                      用户对该页面的授权权限，勾选后可操作页面下挂资源的授权权限。
                    </li>
                    <li>页面或某个资源的授权权限默认拥有其查看权限。</li>
                    <li>
                      授权权限用于权限管理中为用户组或个人授权，可授予用户查看和编辑的权限。
                    </li>
                    <li>
                      勾选授权全部表示用户可以为页面下挂的所有资源授权，包括之后页面新增的资源。
                    </li>
                  </ul>
                );
              }}
            >
              <InfoCircleOutlined className="tips" />
            </Popover>
            {UserPermissionStore.data.hasChildResource && (
              <div className="readRadio">
                <Radio.Group
                  onChange={(e) =>
                    UserPermissionStore.onChangeRadio(e, "grantAll")
                  }
                  value={UserPermissionStore.data.grantAll}
                  disabled={
                    !UserPermissionStore.data.grantAllOperable ||
                    !UserPermissionStore.data.grantable
                  }
                >
                  <Radio value={true}>全部</Radio>
                  <Radio value={false}>仅勾选</Radio>
                </Radio.Group>
              </div>
            )}
          </div>
          <div className="readTop">
            <span style={{ fontSize: "20px", paddingRight: "10px" }}>管理</span>{" "}
            <Checkbox
              onChange={(e) => UserPermissionStore.topCheckbox(e, "manageable")}
              checked={UserPermissionStore.data.manageable}
              disabled={!UserPermissionStore.data.manageOperable}
              style={{ fontSize: "22px", paddingBottom: "16px" }}
            ></Checkbox>
            <Popover
              placement="bottom"
              className="tips1"
              content={() => {
                return (
                  <ul style={{ width: "225px", padding: "0 0 0 15px" }}>
                    <li>
                      用户对该页面的管理权限，勾选后可操作页面下挂资源的管理权限。
                    </li>
                    <li>
                      页面或某个资源的管理权限默认拥有其查看、编辑、授权的权限。
                    </li>
                    <li>
                      管理权限可用于权限管理中为用户组或个人授权，可授予用户查看，编辑，授权，管理的权限。
                    </li>
                    <li>
                      勾选管理全部表示用户可以管理页面下挂的所有资源，包括之后页面新增的资源。
                    </li>
                  </ul>
                );
              }}
            >
              <InfoCircleOutlined className="tips" />
            </Popover>
            {UserPermissionStore.data.hasChildResource && (
              <div className="readRadio">
                <Radio.Group
                  onChange={(e) =>
                    UserPermissionStore.onChangeRadio(e, "manageAll")
                  }
                  value={UserPermissionStore.data.manageAll}
                  disabled={
                    !UserPermissionStore.data.manageAllOperable ||
                    !UserPermissionStore.data.manageable
                  }
                >
                  <Radio value={true}>全部</Radio>
                  <Radio value={false}>仅勾选</Radio>
                </Radio.Group>
              </div>
            )}
          </div>
        </div>
        <ConfigProvider renderEmpty={tableEmptyRender}>
          {UserPermissionStore.data.hasChildResource && (
            <Table
              dataSource={UserPermissionStore.data.resourceList}
              rowKey={(record) => record.value}
              loading={UserPermissionStore.tableLoad}
              scroll={{ x: 800, y: "calc(100vh - 400px)" }}
              pagination={false}
              size="small"
              style={{ padding: "0 32px" }}
              rowClassName="ant-table1"
            >
              <Column
                width={100}
                title="资源名称"
                dataIndex="label"
                align="center"
              />

              {Object.keys(UserPermissionStore.permissionsText).map(
                (item, index) => {
                  return (
                    <Column
                      ellipsis={true}
                      width={150}
                      key={index}
                      title={() => {
                        return (
                          <Checkbox
                            checked={
                              UserPermissionStore.checkboxAll[item] ||
                              UserPermissionStore.data[
                                UserPermissionStore.getAll[item]
                              ]
                            }
                            indeterminate={
                              UserPermissionStore.indeterminate[item] &&
                              !UserPermissionStore.data[
                                UserPermissionStore.getAll[item]
                              ]
                            }
                            onChange={(e) =>
                              UserPermissionStore.changeCheckAll(e, item)
                            }
                            disabled={
                              UserPermissionStore.data[
                                UserPermissionStore.getAll[item]
                              ] ||
                              !UserPermissionStore.data[item] ||
                              !UserPermissionStore.data[
                                UserPermissionStore.getOperable[item]
                              ]
                            }
                          >
                            {UserPermissionStore.permissionsText[item]}
                          </Checkbox>
                        );
                      }}
                      align="center"
                      render={(record) => {
                        return (
                          <Checkbox
                            onChange={(e) =>
                              UserPermissionStore.changeCheckbox(
                                e,
                                record,
                                item
                              )
                            }
                            checked={
                              record[item] ||
                              UserPermissionStore.data[
                                UserPermissionStore.getAll[item]
                              ]
                            }
                            disabled={
                              !record[UserPermissionStore.getOperable[item]] ||
                              UserPermissionStore.data[
                                UserPermissionStore.getAll[item]
                              ] ||
                              !UserPermissionStore.data[item]
                            }
                          ></Checkbox>
                        );
                      }}
                    />
                  );
                }
              )}
            </Table>
          )}
        </ConfigProvider></div>
        
      </Modal>
    </Fragment>
  );
}

export default observer(PermissionPage);
